import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import { DEFAULT_BUTTON_CONFIG } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class SpriteLabel extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,type, name) {
    super(scene);

    this.doAction = () => {};
    this.sprite = ABCyaPhaser.Images.addImage(0,0,name, this);

    if (type === 1) {
      this.textLabel = ABCyaPhaser.Text.addText(0,-110, `${18}pt`, 0x000000, FontKeys._odin_roundedregular, 'You did it!', this, true).setOrigin(0.5);

      this.textLabel2 = ABCyaPhaser.Text.addText(0,-70, `${18}pt`, 0x000000, FontKeys._odin_roundedregular, 'Happy Valentine\'s Day!', this, true).setOrigin(0.5);

      this.textLabel3 = ABCyaPhaser.Text.addText(0,-30, `${18}pt`, 0x000000, FontKeys._odin_roundedregular, 'Tap on the candy to eat it.', this, true).setOrigin(0.5);
    }
    else if (type === 2) {
      this.textLabel = ABCyaPhaser.Text.addText(0,-110, `${18}pt`, 0x000000, FontKeys._odin_roundedregular, 'You ate all the candy!', this, true).setOrigin(0.5);

      this.textLabel2 = ABCyaPhaser.Text.addText(0,-70, `${18}pt`, 0x000000, FontKeys._odin_roundedregular, 'Don\'t forget to brush your teeth!', this, true).setOrigin(0.5);
    }
    else if (type === 3) {
      this.textLabel = ABCyaPhaser.Text.addText(0,-110, `${18}pt`, 0x000000, FontKeys._odin_roundedregular, 'Oh no!', this, true).setOrigin(0.5);

      this.textLabel2 = ABCyaPhaser.Text.addText(0,-70, `${18}pt`, 0x000000, FontKeys._odin_roundedregular, 'The chocolates fell out of the box!', this, true).setOrigin(0.5);

      this.textLabel3 = ABCyaPhaser.Text.addText(0,-30, `${18}pt`, 0x000000, FontKeys._odin_roundedregular, 'Can you put them back to where they belong?', this, true).setOrigin(0.5);
    }

    this.button = ABCyaPhaser.Buttons.addDefaultButton(0,90, UIAssetKeys._go_button, null, null, () => this.removeLabel(), this, DEFAULT_BUTTON_CONFIG);
  }

  removeLabel () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);
    this.doAction();

    this.destroy();
  }
}